<template>
  <div class="main">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">车号：</span>
        <el-input v-model="search.carNumber" :size="size" clearable placeholder="请输入车号"></el-input>
      </div>
      <div class="header_item">
        <span class="header_label">货名：</span>
        <el-input v-model="search.tradeName" :size="size" clearable placeholder="请输入货名"></el-input>
      </div>
      <div class="header_item">
        <span class="header_label">时间范围：</span>
        <el-date-picker
            v-model="search.time"
            type="daterange"
            :default-time="['00:00:00','23:59:59']"
            clearable
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="-"
            start-placeholder="起始时间"
            end-placeholder="结束时间">
        </el-date-picker>
      </div>
      <div class="header_item">
        <el-button icon="el-icon-search" v-if="showButton('search')" @click="searchButtonInfo(true)">查询</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="dataList"
        height="100%">
        <el-table-column align="center" label="序号" width="60">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间" align="center" width="150"></el-table-column>
        <el-table-column prop="serialNumber" label="流水号" align="center" width="120"></el-table-column>
        <el-table-column prop="carNumber" label="车号" align="center"></el-table-column>
        <el-table-column prop="weighType" label="过磅类型" align="center"></el-table-column>
        <el-table-column prop="forwardingUnit" label="发货单位" align="center" width="180"></el-table-column>
        <el-table-column prop="consignee" label="收货单位" align="center" width="200"></el-table-column>
        <el-table-column prop="tradeName" label="货名" align="center"></el-table-column>
        <el-table-column prop="specifications" label="规格" align="center"></el-table-column>
        <el-table-column prop="grossWeight" label="毛重" align="center"></el-table-column>
        <el-table-column prop="tare" label="皮重" align="center"></el-table-column>
        <el-table-column prop="netWeight" label="净重" align="center"></el-table-column>
        <el-table-column prop="buckleWeight" label="扣重" align="center"></el-table-column>
        <el-table-column prop="actualWeight" label="实重" align="center"></el-table-column>
        <el-table-column prop="unitPrice" label="单价" align="center"></el-table-column>
        <el-table-column prop="amountOfMoney" label="金额" align="center"></el-table-column>
        <el-table-column prop="coefficientOfReduction" label="折方系数" align="center"></el-table-column>
        <el-table-column prop="quantity" label="方量" align="center"></el-table-column>
        <el-table-column prop="weighingFee" label="过磅费" align="center"></el-table-column>
        <el-table-column prop="grossWeightWeigher" label="毛重司磅员" align="center" width="100"></el-table-column>
        <el-table-column prop="tareWeightman" label="皮重司磅员" align="center" width="100"></el-table-column>
        <el-table-column prop="grossPound" label="毛重磅号" align="center"></el-table-column>
        <el-table-column prop="piPound" label="皮重磅号" align="center"></el-table-column>
        <el-table-column prop="grossTime" label="毛重时间" align="center" width="150"></el-table-column>
        <el-table-column prop="skinTime" label="皮重时间" align="center" width="150"></el-table-column>
        <el-table-column prop="oneCrossTime" label="一次过磅时间" align="center" width="150"></el-table-column>
        <el-table-column prop="twoCrossTime" label="二次过磅时间" align="center" width="150"></el-table-column>
        <el-table-column prop="updateBy" label="更新人" align="center"></el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { buttonPinia } from '../../pinia/index';
import { changeSize } from '../../plugins/public'; // 导入节流、动态切换组件尺寸方法
  export default {
    data() {
      return {
        size: changeSize(), // 组件尺寸
        pageNum: 1,
        pageSize: 10,
        search:{},//查询条件
        total: 0,
        loading: false,
        dataList: [], //进场称重列表
      }
    },
    watch: {
      asyncVisible(bol) {
        if(!bol) {
          this.ruleForm = {};
          this.$refs.ruleForm.resetFields();
        }
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.searchButtonInfo(true);
    },
    methods: {
      // 查询按钮列表信息
      searchButtonInfo(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        let params = Object.assign({},this.search,{
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
        params.startTime = this.search.time&&this.search.time[0]
        params.endTime = this.search.time&&this.search.time[1]
        delete params.time
        this.loading = true;
        this.$api.Materials.searchWeighRecordsList(params).then((res) => {
          if(res.statusMsg === 'ok') {
            this.total = res.data.total;
            this.dataList = res.data.list;
          }
          this.loading = false;
        })
      },
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },      
      // 切换页数
      changePageNum(page) {
        this.pageNum = page;
        this.searchButtonInfo();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchButtonInfo();
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '../../style/layout-main.scss';
/deep/.el-color-picker__trigger{
  border-color:#1C4390;
}
/deep/.el-color-picker__color{
  border-color:#1C4390;
}
//滚动条样式
/deep/ ::-webkit-scrollbar {
    width: 4px; 
    height: 8px;   
}
/deep/ ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 5px #084E6B;
    background: rgba(0,0,0,0.2);
}
/deep/ ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px transparent;
    border-radius: 0;
    background: transparent;
}
</style>